import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { CalibrationId, CalibrationGear } from 'services/equipmentSets/types';
import { makeSelectCalibrationGear } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    gear: CalibrationGear;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsGearListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { gear } = this.props;

        return <ListItem description="Gear" value={gear} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    gear: makeSelectCalibrationGear()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsGearListItemComponent
);
